// extracted by mini-css-extract-plugin
module.exports = {"carousel":"styles_carousel__TqWd2","card":"styles_card__dx2c1","product":"styles_product__3aiZG","loading":"styles_loading__aHT18"};